// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BreederRole, BreederRoleSchema } from 'api/gen/BreederRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(BreederRoleSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelBreederRoleSchema = excess(requiredPart);

export interface PagedModelBreederRole extends t.TypeOf<typeof PagedModelBreederRoleSchema> {}
